"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./index.scss");
const contexts_1 = require("@App/contexts");
const create_rightsholder_1 = require("@Entities/schemas/rightsholder/create-rightsholder");
const react_hook_form_1 = require("react-hook-form");
const zod_1 = require("@hookform/resolvers/zod");
const FormFieldFromProps_1 = __importDefault(require("@Fields/v2/FormFieldFromProps"));
const PhoneNumberForm_1 = __importDefault(require("@Fields/v2/PhoneNumberForm"));
const IdentifiersSection_1 = __importDefault(require("@Scenes/RightsholderRegistrationLayout/RightsholderRegistrationForm/IdentifiersSection"));
const MemberDetailsSection_1 = __importDefault(require("@Scenes/RightsholderRegistrationLayout/RightsholderRegistrationForm/MemberDetailsSection"));
const Button_1 = require("@Components/Buttons/Button");
const common_1 = require("@Const/common");
const react_router_dom_1 = require("react-router-dom");
const navigation_1 = __importDefault(require("@App/navigation"));
const CheckboxForm_1 = __importDefault(require("@Fields/v2/CheckboxForm"));
const mobx_react_1 = require("mobx-react");
const RightsholderAddress_1 = __importDefault(require("@Scenes/RightsholderRegistrationLayout/RightsholderRegistrationForm/RightsholderAddress"));
const RightsholderRegistrationSceneHeader_1 = __importDefault(require("@Scenes/RightsholderRegistrationLayout/RightsholderRegistrationSceneHeader"));
const rightsholder_1 = require("@App/api/routes/rightsholder/rightsholder");
const convert_empty_values_to_undefined_1 = __importDefault(require("@App/forms/v2/helpers/convert-empty-values-to-undefined"));
const IdentifiersToolTip_1 = __importDefault(require("@Scenes/RightsholderRegistrationLayout/RightsholderRegistrationForm/IdentifiersSection/IdentifiersToolTip"));
const RightsholderRegistrationForm = () => {
    var _a;
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { preloaderStore, createRightsholderStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const location = (0, react_router_dom_1.useLocation)();
    const methods = (0, react_hook_form_1.useForm)({
        mode: 'onChange',
        criteriaMode: 'all',
        reValidateMode: 'onChange',
        delayError: 750,
        resolver: (0, zod_1.zodResolver)(create_rightsholder_1.createRightsholderFormSchema),
        defaultValues: { memberType: ((_a = location.state) === null || _a === void 0 ? void 0 : _a.memberType) || undefined },
    });
    const onSubmit = (data) => __awaiter(void 0, void 0, void 0, function* () {
        preloaderStore.openTransparentPreloader(true);
        data = (0, convert_empty_values_to_undefined_1.default)(data, true);
        data.address = (0, convert_empty_values_to_undefined_1.default)(data.address, true);
        data.phoneNumber = (0, convert_empty_values_to_undefined_1.default)(data.phoneNumber, true);
        if (data.hfaPublisherNumber) {
            try {
                const doesUserAlreadyHaveMemberWithHfaPublisherNumber = yield (0, rightsholder_1.verifyRightsholder)(data.hfaPublisherNumber);
                if (doesUserAlreadyHaveMemberWithHfaPublisherNumber.data) {
                    methods.setError('hfaPublisherNumber', {
                        type: 'manual',
                        message: 'This Publisher Number is already in use.',
                    });
                    preloaderStore.openTransparentPreloader(false);
                    return;
                }
            }
            catch (ignore) {
                methods.setError('hfaPublisherNumber', {
                    type: 'manual',
                    message: 'No account found with Publisher Account Number.',
                });
                preloaderStore.openTransparentPreloader(false);
                return;
            }
        }
        createRightsholderStore.setCreateRightsholderForm(data);
        navigate(navigation_1.default.registrationRightsholder.questionnaire());
        preloaderStore.openTransparentPreloader(false);
    });
    const { memberType, memberSubType, name, hfaPublisherNumber, ipiNumber, isni, address, phoneNumber, email, termsAndConditions, } = create_rightsholder_1.createRightsholderFormFields;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(RightsholderRegistrationSceneHeader_1.default, null),
        react_1.default.createElement(react_hook_form_1.FormProvider, Object.assign({}, methods),
            react_1.default.createElement("form", { onSubmit: methods.handleSubmit(onSubmit) },
                react_1.default.createElement("div", { className: "register-rightsholder-form" },
                    react_1.default.createElement(MemberDetailsSection_1.default, { name: name, memberType: memberType, memberSubType: memberSubType }),
                    react_1.default.createElement(IdentifiersSection_1.default, { hfaPublisherNumber: hfaPublisherNumber, isni: isni, ipiNumber: ipiNumber, identifierToolTip: react_1.default.createElement(IdentifiersToolTip_1.default, null) }),
                    react_1.default.createElement(RightsholderAddress_1.default, { address: address }),
                    react_1.default.createElement("h5", null, "Member Contact"),
                    react_1.default.createElement(PhoneNumberForm_1.default, { phoneNumberFormFields: phoneNumber }),
                    react_1.default.createElement(FormFieldFromProps_1.default, { field: email }),
                    react_1.default.createElement(CheckboxForm_1.default, Object.assign({}, termsAndConditions),
                        react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("a", { href: "https://www.themlc.com/portaltermsofuse", target: '_blank', className: "small", rel: "noreferrer" }, "Terms of Use"),
                            ' ',
                            react_1.default.createElement("strong", { className: 'blue-text' }, "Required"))),
                    react_1.default.createElement(Button_1.Button, { type: 'primary', icon: common_1.ICONS.arrow_forward, mainColor: true, submitType: 'submit' }, "Next"))))));
};
exports.default = (0, mobx_react_1.observer)(RightsholderRegistrationForm);
